/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useRef, useState } from "react";
import { Checkbox, Col, Form, Row } from "antd";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import StyledCheckBoxWithLabel from "../../../styled-components/StyledCheckboxWithLabel";
import {
  TI_1000_RADIUS_BUTTON,
  TI_SEARCH_RADIUS_1000,
} from "../../../Constants";

export const OPTIONS_WIFI = [
  { value: "공공,지자체", label: "공공 WIFI", iconCode: "공공wifi" },
  { value: "SKT,KT,LGT", label: "통신사 WIFI", iconCode: "통신사wifi" },
];

function WidgetWifi() {
  const { widgetState, onChangeWidgetState, iconDict } =
    useContext(MapPropsContext);
  const { wifi_code } = widgetState;
  const [state, setState] = useState({
    indeterminate: wifi_code.length < OPTIONS_WIFI.length,
    checkAll: wifi_code.length === OPTIONS_WIFI.length,
  });

  const onCheckAllChange = useCallback(({ target: { checked } }) => {
    setState({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: "wifi_code",
        value: !checked ? [] : OPTIONS_WIFI.map(({ value }) => value),
      },
    });
  }, []);

  const onChange = useCallback(
    (checkedValues) => {
      setState({
        indeterminate:
          !!checkedValues.length && checkedValues.length < OPTIONS_WIFI.length,
        checkAll: checkedValues.length === OPTIONS_WIFI.length,
      });

      onChangeWidgetState({
        target: {
          name: "wifi_code",
          value: checkedValues,
        },
      });
    },
    [onChangeWidgetState, setState]
  );

  const { indeterminate, checkAll } = state;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 8,
        }}
      >
        <Title>와이파이 구분</Title>
        <StyledCheckBoxWithLabel
          label="전체 선택"
          checked={checkAll}
          tabIndex={TI_SEARCH_RADIUS_1000 + 1}
          onChange={onCheckAllChange}
        />
        {/* <Checkbox
          checked={checkAll}
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
        >
          전체 선택
        </Checkbox> */}
      </div>
      {/* <Title
        extra={
          <Checkbox
            checked={checkAll}
            indeterminate={indeterminate}
            onChange={onCheckAllChange}
          >
            전체 선택
          </Checkbox>
        }
      >
        와이파이 구분
      </Title> */}
      {/* <Checkbox.Group
        name="wifi_code"
        value={wifi_code}
        onChange={(e) => {
          // onChange;
          console.log(e);
        }}
        size={"small"}
        style={{ width: "100%" }}
      > */}
      <Row>
        {OPTIONS_WIFI.map(({ value, label, iconCode }, index) => {
          const { data, width, height } = iconDict[iconCode] || {};
          const iconWidth = 24;
          const ratio = iconWidth / width;
          const iconHeight = Math.floor(height * ratio);
          return (
            <Col span={12} key={value}>
              <StyledCheckBoxWithLabel
                checked={wifi_code.includes(value)}
                label={label}
                tabIndex={TI_SEARCH_RADIUS_1000 + 2 + index}
                onChange={() => {
                  const index = widgetState.wifi_code.indexOf(value);
                  let checkedValues = [...widgetState.wifi_code];
                  if (index === -1) {
                    checkedValues.push(value);
                  } else {
                    checkedValues.splice(index, 1);
                  }
                  onChangeWidgetState({
                    target: {
                      name: "wifi_code",
                      value: checkedValues,
                    },
                  });
                }}
              >
                {data && (
                  <img
                    src={data}
                    style={{
                      width: iconWidth,
                      height: iconHeight,
                      marginLeft: 4,
                    }}
                    alt={""}
                  />
                )}
              </StyledCheckBoxWithLabel>
              {/* <Checkbox value={value} key={label}></Checkbox> */}
            </Col>
          );
        })}
      </Row>
      {/* </Checkbox.Group> */}
      <br />
    </div>
  );
}

export default WidgetWifi;
